import { render, staticRenderFns } from "./BasePriceInput.vue?vue&type=template&id=613d044e&scoped=true"
import script from "./BasePriceInput.vue?vue&type=script&lang=js"
export * from "./BasePriceInput.vue?vue&type=script&lang=js"
import style0 from "./BasePriceInput.vue?vue&type=style&index=0&id=613d044e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613d044e",
  null
  
)

export default component.exports